import React, { ReactNode } from 'react';
import logo from '../assets/logo.png';
import styles from './AuthLayout.module.css';

interface AuthLayoutProps {
  logoSize?: number;
  maxWidth?: number;
  topPadding?: number;
  logoMarginBottom?: number;
  titleColor?: string;
  title: string;
  subtitle?: string;
  banner?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

export default function AuthLayout({
  logoSize = 200,
  maxWidth,
  topPadding,
  logoMarginBottom,
  titleColor,
  title,
  subtitle,
  banner,
  children,
  footer,
}: AuthLayoutProps) {
  return (
    <div className={styles.page}>
      <div
        className={styles.card}
        style={{
          ...(maxWidth ? { maxWidth } : undefined),
          ...(topPadding !== undefined ? { paddingTop: topPadding } : undefined),
        }}
      >
        {banner}
        <img
          src={logo}
          alt="SC Lab"
          className={styles.logo}
          style={{
            width: logoSize,
            height: logoSize,
            ...(logoMarginBottom !== undefined ? { marginBottom: logoMarginBottom } : undefined),
          }}
        />
        <h1 className={styles.title} style={titleColor ? { color: titleColor } : undefined}>
          {title}
        </h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        <hr className={styles.separator} />
        {children}
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
}
